import script from "./SubMenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenuComponent.vue?vue&type=script&setup=true&lang=js"

import "./SubMenuComponent.vue?vue&type=style&index=0&id=18c11d3c&lang=scss"

const __exports__ = script;

export default __exports__